<ng-container *ngIf="!purchasedProduct?.coverage?.coveragesAdjustmentStartDate">
    <div
        *ngIf="
            ![productIdEnum.Accidents, productIdEnum.Liability].includes(purchasedProduct?.productId)
        "
    >
        <wuc-button
            *ngIf="![
                    validityStatusCodeEnum.Disbarred,
                    validityStatusCodeEnum.Future,
                    validityStatusCodeEnum.ActiveEnded
                ].includes(purchasedProduct?.product?.validityStatusCode)"
            type="secondary"
            [isFullWidth]="intersectionObserverService.isScreenSmall$ | async "
            (buttonClick)="addCoverage()"
        >Dekking wijzigen</wuc-button>
        <wuc-button
            *ngIf="
                [
                    validityStatusCodeEnum.Disbarred,
                    validityStatusCodeEnum.Future,
                    validityStatusCodeEnum.ActiveEnded
                ].includes(purchasedProduct?.product?.validityStatusCode)
            "
            type="secondary"
            [disabled]="true"
            [isFullWidth]="intersectionObserverService.isScreenSmall$ | async "
            [insTooltip]="
                'U kunt nu de dekking niet wijzigen, omdat de verzekering stopt op ' +
                (purchasedProduct?.product?.endDate | dateFormat) +
                '. Klik op \'toch niet opzeggen\' als u uw dekking wilt aanpassen.'
            "
        >
            Dekking wijzigen
        </wuc-button>
    </div>
</ng-container>
<ng-container *ngIf="purchasedProduct?.coverage?.coveragesAdjustmentStartDate">
    <ng-container
        *ngIf="
            ![validityStatusCodeEnum.Future, validityStatusCodeEnum.Transfer].includes(
                purchasedProduct?.product?.validityStatusCode
            )
        "
    >
        <wuc-button type="secondary" (buttonClick)="onCancelAddedCoverage()">
            Wijziging annuleren
        </wuc-button>
    </ng-container>
</ng-container>
